var exports = {
  "v": "RiverAccordion__XIT8iu",
};

module.exports = exports;
